"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var getDetailsFromDate = function getDetailsFromDate(date) {
  var _date$substring$split = date.substring(0, 10).split('-'),
      _date$substring$split2 = (0, _slicedToArray2["default"])(_date$substring$split, 3),
      year = _date$substring$split2[0],
      month = _date$substring$split2[1],
      day = _date$substring$split2[2];

  return {
    year: year,
    month: month,
    day: day
  };
};

var _default = getDetailsFromDate;
exports["default"] = _default;
//# sourceMappingURL=getDetailsFromDate.js.map